/**
 * Public survey module — self-contained; see README.md.
 *
 * The host app mounts it before its own router:
 *
 *   const surveyRoute = resolveSurveyRoute(window.location);
 *   ReactDOM.render(surveyRoute ? <SurveyApp route={surveyRoute} /> : <App />, root);
 */
import { SURVEY_HOSTS, SURVEY_PATH_PREFIX } from './survey.config';

export { default as SurveyApp } from './SurveyApp';

/**
 * Is this page load a survey? → { key, base } or null.
 *   survey host   /          → { key: null,      base: '' }        (chooser)
 *   survey host   /student   → { key: 'student', base: '' }
 *   any host      /survey    → { key: null,      base: '/survey' }
 *   any host      /survey/student → { key: 'student', base: '/survey' }
 */
export const resolveSurveyRoute = ({ hostname, pathname }) => {
    const parts = (pathname || '/').split('/').filter(Boolean);
    if (SURVEY_HOSTS.includes(String(hostname).toLowerCase())) {
        return { key: parts[0] || null, base: '' };
    }
    if (`/${parts[0] || ''}` === SURVEY_PATH_PREFIX) {
        return { key: parts[1] || null, base: SURVEY_PATH_PREFIX };
    }
    return null;
};
